var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41797 1.16675H5.2513C2.33464 1.16675 1.16797 2.33341 1.16797 5.25008V8.75008C1.16797 11.6667 2.33464 12.8334 5.2513 12.8334H8.7513C11.668 12.8334 12.8346 11.6667 12.8346 8.75008V7.58342",
    stroke: "#161F28",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35806 1.76157L4.76139 6.35824C4.58639 6.53324 4.41139 6.8774 4.37639 7.12824L4.12556 8.88407C4.03223 9.5199 4.48139 9.96324 5.11723 9.87574L6.87306 9.6249C7.11806 9.5899 7.46223 9.4149 7.64306 9.2399L12.2397 4.64324C13.0331 3.8499 13.4064 2.92824 12.2397 1.76157C11.0731 0.594903 10.1514 0.968237 9.35806 1.76157Z",
    stroke: "#161F28",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69922 2.4209C9.09005 3.81507 10.1809 4.9059 11.5809 5.30257",
    stroke: "#161F28",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditP);
export default __webpack_public_path__ + "static/media/edit-p.ce5d76348c8734820a1110aff468edef.svg";
export { ForwardRef as ReactComponent };